/**
 * Asset Management — shared constants (roles, permissions, query keys).
 */

/** Roles allowed to reach any admin-gated asset route. Mirrors the menu provider. */
export const ASSET_ADMIN_ROLES = ['AssetAdmin', 'Admin'];

/** Staff/read roles — see the user-facing (My Assets / Scan) surfaces. */
export const ASSET_STAFF_ROLES = ['Staff', 'AssetReader', 'AssetAdmin', 'Admin'];

/** Feature flags. The "pending acknowledgements" panel fans out getAssignments
 *  per owned asset (no dedicated endpoint), so it is capped + flag-gated. */
export const ASSET_FLAGS = {
  pendingAckFanOut: true,
  pendingAckMaxAssets: 25,
} as const;

/** Backend CcmsAuthorize permissions. */
export const ASSET_PERMISSIONS = {
  view: 'Asset.View',
  create: 'Asset.Create',
  update: 'Asset.Update',
  delete: 'Asset.Delete',
  transfer: 'Asset.Transfer',
  settings: 'Asset.Settings',
  manage: 'Asset.Manage',
} as const;

/** React Query keys for the asset domain. */
export const assetKeys = {
  all: ['asset'] as const,
  list: (filter?: unknown) => ['asset', 'list', filter ?? {}] as const,
  myList: (userId?: string | null, filter?: unknown) => ['asset', 'my-list', userId ?? '', filter ?? {}] as const,
  pendingAcks: (userId?: string | null) => ['asset', 'pending-acks', userId ?? ''] as const,
  detail: (id: number) => ['asset', 'detail', id] as const,
  assignments: (id: number) => ['asset', 'assignments', id] as const,
  statusHistory: (id: number) => ['asset', 'status-history', id] as const,
  tags: (id: number) => ['asset', 'tags', id] as const,
  maintenance: (id: number) => ['asset', 'maintenance', id] as const,
  scans: (id: number) => ['asset', 'scans', id] as const,
  settings: () => ['asset', 'settings'] as const,
  channels: () => ['asset', 'channels'] as const,
};
